<template>
	<div>
		<v-layout wrap class="footer_1_layout px-pc" v-if="nowWidth > 784">
			<v-layout wrap>
				<v-flex xs6>
					<div class="footer-content">
						<div class="t">
							세마인베스트먼트㈜
						</div>
						<div class="c">
							서울시 강남구 영동대로 416, 3층 (대치동, KT&G타워)<br />
							T 02 3484 7081<br />
							E admin@semainv.com
						</div>
						<div class="c mt-4">
							<span class="cursor" @click="setdialog.dialog = true">
								개인정보 처리방침
							</span>
							<span class="mx-4">
								|
							</span>
							<span class="cursor" @click="$router.push('/contact')">
								찾아오시는 길
							</span>
						</div>
					</div>
				</v-flex>
				<v-spacer></v-spacer>
				<v-flex xs6>
					<div class="footer_2_layout footer-content">
						<div class="footer_logo_1 cursor" @click="link()"></div>
						<div class="t">
							(사)과학기술인공제회
						</div>
					</div>
				</v-flex>
			</v-layout>
		</v-layout>
		<v-layout wrap class="m_footer_1_layout" v-else>
			<v-layout wrap>
				<v-flex sm6 xs12>
					<div class="m_footer-content">
						<div class="t">
							세마인베스트먼트㈜
						</div>
						<div class="c">
							서울시 강남구 영동대로 416, 3층 (대치동, KT&G타워)<br />
							T 02 3484 7081<br />
							E admin@semainv.com
						</div>
						<div class="c mt-4">
							<span class="cursor" @click="setdialog.dialog = true">
								개인정보 처리방침
							</span>
							<span class="mx-4">
								|
							</span>
							<span class="cursor" @click="$router.push('/contact')">
								찾아오시는 길
							</span>
						</div>
					</div>
				</v-flex>
				<v-spacer></v-spacer>
				<v-flex sm6 xs12>
					<v-layout :justify-end="$vuetify.breakpoint.smAndUp" :justify-center="$vuetify.breakpoint.xs" align-end class="mt-4">
						<div class="m_footer-content">
							<div class="m_footer_logo_1 cursor" @click="link()"></div>
							<div class="t">
								(사)과학기술인공제회
							</div>
						</div>
					</v-layout>
				</v-flex>
			</v-layout>
		</v-layout>
		<v-dialog v-model="setdialog.dialog" max-width="160vh" persistent>
			<v-card class="dialog1">
				<div class="qrtitle">
					<v-spacer />
					<v-icon @click="setdialog.dialog = false" class="title-icon">mdi-close</v-icon>
				</div>
				<div class="dialog-content" :style="nowWidth > 784 ? '' : 'padding:0 4px !important; margin: 0 !important'">
					<p class="title">{{ setdialog.title }}</p>
					<p class="content">{{ setdialog.content }}</p>
				</div>
			</v-card>
		</v-dialog>
	</div>
</template>
<script>
export default {
	data() {
		return {
			screenWidth: window.innerWidth,
			setdialog: {
				dialog: false,
				title: 'Privacy Policy',
				content: `
				[이용약관]
제 1 조 (목적)
이약관은 SEMA INV(이하 "회사")가제공하는 서비스의이용과 관련하여 회사와 회원과의권리, 의무및책임사항, 기타필요한사항을규정함을목적으로합니다.
제 2 조 (정의)
이약관에서사용하는용어의정의는다음과같습니다.
"서비스"라함은구현되는단말기(PC, TV, 휴대형단말기등의각종유무선장치를포함)와상관없이 "회원"이이용할수있는 SEMA INV와관련제반서비스를의미합니다.
"회원"이라함은회사의 "서비스"에접속하여이약관에따라 "회사"와이용계약을체결하고 "회사"가제공하는 "서비스"를이용하는고객을말합니다.
"아이디(ID)"라함은 "회원"의식별과 "서비스" 이용을위하여 "회원"이정하고 "회사"가승인하는문자와숫자의조합을의미합니다.
"비밀번호"라함은 "회원"이부여받은 "아이디와일치되는 "회원"임을확인하고비밀보호를위해 "회원" 자신이정한문자또는숫자의조합을의미합니다.
"유료서비스"라함은 "회사"가유료로제공하는각종온라인디지털콘텐츠(각종정보콘텐츠, VOD, 아이템기타유료콘텐츠를포함) 및제반서비스를의미합니다.
"포인트"라함은서비스의효율적이용을위해회사가임의로책정또는지급, 조정할수있는재산적가치가없는 "서비스" 상의가상데이터를의미합니다.
"게시물"이라함은 "회원"이 "서비스"를이용함에있어 "서비스상"에게시한부호ㆍ문자ㆍ음성ㆍ음향ㆍ화상ㆍ동영상등의정보형태의글, 사진, 동영상및각종파일과링크등을의미합니다.
제 3 조 (약관의게시와개정)
"회사"는이약관의내용을 "회원"이쉽게알수있도록서비스초기화면에게시합니다.
"회사"는 "약관의규제에관한법률", "정보통신망이용촉진및정보보호등에관한법률(이하 "정보통신망법")" 등관련법을위배하지않는범위에서이약관을개정할수있습니다.
"회사"가약관을개정할경우에는적용일자및개정사유를명시하여현행약관과함께제1항의방식에따라그개정약관의적용일자 30일전부터적용일자전일까지공지합니다.
다만, 회원에게불리한약관의개정의경우에는공지외에일정기간서비스내전자우편, 전자쪽지, 로그인시동의창등의전자적수단을통해따로명확히통지하도록합니다.
회사가전항에따라개정약관을공지또는통지하면서회원에게 30일기간내에의사표시를하지않으면의사표시가표명된것으로본다는뜻을명확하게공지또는통지하였음에도회원이명시적으로거부의의사표시를하지아니한경우회원이개정약관에동의한것으로봅니다.
회원이개정약관의적용에동의하지않는경우회사는개정약관의내용을적용할수없으며, 이경우회원은이용계약을해지할수있습니다. 다만, 기존약관을적용할수없는특별한사정이있는경우에는회사는이용계약을해지할수있습니다.
제 4 조 (약관의해석)
"회사"는 "유료서비스" 및개별서비스에대해서는별도의이용약관및정책(이하 "유료서비스약관등")을둘수있으며, 해당내용이이약관과상충할경우에는 "유료서비스약관등"이우선하여적용됩니다.
이약관에서정하지아니한사항이나해석에대해서는 "유료서비스약관등" 및관계법령또는상관례에따릅니다.
제 5 조 (이용계약체결)
이용계약은 "회원"이되고자하는자(이하 "가입신청자")가약관의내용에대하여동의를한다음회원가입신청을하고 "회사"가이러한신청에대하여승낙함으로써체결됩니다.
"회사"는 "가입신청자"의신청에대하여 "서비스" 이용을승낙함을원칙으로합니다. 다만, "회사"는다음각호에해당하는신청에대하여는승낙을하지않거나사후에이용계약을해지할수있습니다.
1.가입신청자가이약관에의하여이전에회원자격을상실한적이있는경우, 단 "회사"의회원재가입승낙을얻은경우에는예외로함.
2.실명이아니거나타인의명의를이용한경우
3.허위의정보를기재하거나, "회사"가제시하는내용을기재하지않은경우
4.14세미만아동이법정대리인(부모등)의동의를얻지아니한경우
5.이용자의귀책사유로인하여승인이불가능하거나기타규정한제반사항을위반하며신청하는경우
제1항에따른신청에있어 "회사"는 "회원"의종류에따라전문기관을통한실명확인및본인인증을요청할수있습니다.
"회사"는서비스관련설비의여유가없거나, 기술상또는업무상문제가있는경우에는승낙을유보할수있습니다.
제2항과제4항에따라회원가입신청의승낙을하지아니하거나유보한경우, "회사"는원칙적으로이를가입신청자에게알리도록합니다.
이용계약의성립시기는 "회사"가가입완료를신청절차상에서표시한시점으로합니다.
"회사"는 "회원"에대해회사정책에따라등급별로구분하여이용시간, 이용횟수, 서비스메뉴등을세분하여이용에차등을둘수있습니다.
"회사"는 "회원"에대하여 "영화및비디오물의진흥에관한법률" 및 "청소년보호법"등에따른등급및연령준수를위해이용제한이나등급별제한을할수있습니다.
제 6 조 (회원정보의변경)
"회원"은개인정보관리화면을통하여언제든지본인의개인정보를열람하고수정할수있습니다.
다만, 서비스관리를위해필요한실명, 주민등록번호, 아이디등은수정이불가능합니다.
"회원"은회원가입신청시기재한사항이변경되었을경우온라인으로수정을하거나전자우편기타방법으로 "회사"에대하여그변경사항을알려야합니다.
제2항의변경사항을 "회사"에알리지않아발생한불이익에대하여 "회사"는책임지지않습니다.
제 7 조 (개인정보보호의무)
"회사"는 "정보통신망법" 등관계법령이정하는바에따라 "회원"의개인정보를보호하기위해노력합니다.
개인정보의보호및사용에대해서는관련법및 "회사"의개인정보취급방침이적용됩니다. 다만, "회사"의공식사이트이외의링크된사이트에서는 "회사"의개인정보취급방침이적용되지않습니다.
제 8 조 ("회원"의 "아이디" 및 "비밀번호"의관리에대한의무)
"회원"의 "아이디"와 "비밀번호"에관한관리책임은 "회원"에게있으며, 이를제3자가이용하도록하여서는안됩니다.
"회사"는 "회원"의 "아이디"가개인정보유출우려가있거나, 반사회적또는미풍양속에어긋나거나 "회사" 및 "회사"의운영자로오인한우려가있는경우, 해당 "아이디"의이용을제한할수있습니다.
"회원"은 "아이디" 및 "비밀번호"가도용되거나제3자가사용하고있음을인지한경우에는이를즉시 "회사"에통지하고 "회사"의안내에따라야합니다.
제3항의경우에해당 "회원"이 "회사"에그사실을통지하지않거나, 통지한경우에도 "회사"의안내에따르지않아발생한불이익에대하여 "회사"는책임지지않습니다.
제 9 조 ("회원"에대한통지)
"회사"가 "회원"에대한통지를하는경우이약관에별도규정이없는한서비스내전자우편주소, 전자쪽지등으로할수있습니다.
"회사"는 "회원" 전체에대한통지의경우 7일이상 "회사"의게시판에게시함으로써제1항의통지에갈음할수있습니다.
제 10 조 ("회사"의의무)
"회사"는관련법과이약관이금지하거나미풍양속에반하는행위를하지않으며, 계속적이고안정적으로 "서비스"를제공하기위하여최선을다하여노력합니다.
"회사"는 "회원"이안전하게 "서비스"를이용할수있도록개인정보(신용정보포함)보호를위해보안시스템을갖추어야하며개인정보취급방침을공시하고준수합니다.
"회사"는서비스이용과관련하여 "회원"으로부터제기된의견이나불만이정당하다고인정할경우에는이를처리하여야합니다. "회원"이제기한의견이나불만사항에대해서는게시판을활용하거나전자우편등을통하여 "회원"에게처리과정및결과를전달합니다.
제 11 조 ("회원"의의무)
"회원"은다음행위를하여서는안됩니다.
1.신청또는변경시허위내용의등록
2.타인의정보도용
3."회사"가게시한정보의변경
4."회사"가정한정보이외의정보(컴퓨터프로그램등) 등의송신또는게시
5."회사"와기타제3자의저작권등지적재산권에대한침해
6."회사" 및기타제3자의명예를손상시키거나업무를방해하는행위
7.외설또는폭력적인메시지, 화상, 음성, 기타공서양속에반하는정보를 "서비스"에공개또는게시하는행위
8.회사의동의없이영리를목적으로 "서비스"를사용하는행위
9.기타불법적이거나부당한행위
"회원"은관계법, 이약관의규정, 이용안내및 "서비스"와관련하여공지한주의사항, "회사"가통지하는사항등을준수하여야하며, 기타 "회사"의업무에방해되는행위를하여서는안됩니다.
제 12 조 ("서비스"의제공등)
회사는회원에게아래와같은서비스를제공합니다.
1.제공서비스
2.개방형서비스(서비스소개, 결재 하기, 온라인상담등)
3.게시판형서비스(온라인상담등)
4.메일서비스
5.기타 "회사"가추가개발하거나다른회사와의제휴계약등을통해 "회원"에게제공하는일체의서비스
회사는 "서비스"를일정범위로분할하여각범위별로이용가능시간을별도로지정할수있습니다. 다만, 이러한경우에는그내용을사전에공지합니다.
"서비스"는연중무휴, 1일 24시간제공함을원칙으로합니다.
"회사"는컴퓨터등정보통신설비의보수점검, 교체및고장, 통신두절또는운영상상당한이유가있는경우 "서비스"의제공을일시적으로중단할수있습니다. 이경우 "회사"는제9조["회원"에대한통지]에정한방법으로 "회원"에게통지합니다.
다만, "회사"가사전에통지할수없는부득이한사유가있는경우사후에통지할수있습니다.
"회사"는서비스의제공에필요한경우정기점검을실시할수있으며, 정기점검시간은서비스제공화면에공지한바에따릅니다.
제 13 조 ("서비스"의변경)
"회사"는상당한이유가있는경우에운영상, 기술상의필요에따라제공하고있는전부또는일부 "서비스"를변경할수있습니다.
"서비스"의내용, 이용방법, 이용시간에대하여변경이있는경우에는변경사유, 변경될서비스의내용및제공일자등은그변경전에해당서비스초기화면에게시하여야합니다.
"회사"는무료로제공되는서비스의일부또는전부를회사의정책및운영의필요상수정, 중단, 변경할수있으며, 이에대하여관련법에특별한규정이없는한 "회원"에게별도의보상을하지않습니다.
제 14 조 (정보의제공및광고의게재)
"회사"는 "회원"이 "서비스" 이용중필요하다고인정되는다양한정보를공지사항이나전자우편등의방법으로 "회원"에게제공할수있습니다. 다만, "회원"은관련법에따른거래관련정보및고객문의등에대한답변등을제외하고는언제든지전자우편에대해서수신거절을할수있습니다.
제1항의정보를전화및모사전송기기에의하여전송하려고하는경우에는 "회원"의사전동의를받아서전송합니다. 다만, "회원"의거래관련정보및고객문의등에대한회신에있어서는제외됩니다.
"회사"는 "서비스"의운영과관련하여서비스화면, 홈페이지, 전자우편등에광고를게재할수있습니다. 광고가게재된전자우편을수신한 "회원"은수신거절을 "회사"에게할수있습니다.
"이용자(회원, 비회원포함)"는회사가제공하는서비스와관련하여게시물또는기타정보를변경, 수정, 제한하는등의조치를취하지않습니다.
제 15 조 ("게시물"의저작권)
"회원"이 "서비스" 내에게시한 "게시물"의저작권은해당게시물의저작자에게귀속됩니다.
"회원"이 "서비스" 내에게시하는 "게시물"은검색결과내지 "서비스" 및관련프로모션등에노출될수있으며, 해당노출을위해필요한범위내에서는일부수정, 복제, 편집되어게시될수있습니다. 이경우, 회사는저작권법규정을준수하며, "회원"은언제든지고객센터또는 "서비스" 내관리기능을통해해당게시물에대해삭제, 검색결과제외, 비공개등의조치를취할수있습니다.
"회사"는제2항이외의방법으로 "회원"의 "게시물"을이용하고자하는경우에는전화, 팩스, 전자우편등을통해사전에 "회원"의동의를얻어야합니다.
제 16 조 ("게시물"의관리)
"회원"의 "게시물"이 "정보통신망법" 및 "저작권법"등관련법에위반되는내용을포함하는경우, 권리자는관련법이정한절차에따라해당 "게시물"의게시중단및삭제등을요청할수있으며, "회사"는관련법에따라조치를취하여야합니다.
"회사"는전항에따른권리자의요청이없는경우라도권리침해가인정될만한사유가있거나기타회사정책및관련법에위반되는경우에는관련법에따라해당 "게시물"에대해임시조치등을취할수있습니다.
본조에따른세부절차는 "정보통신망법" 및 "저작권법"이규정한범위내에서 "회사"가정한 "게시중단요청서비스"에따릅니다.
- 게시중단요청서비스 : contact@bdavc.com
제 17 조 (권리의귀속)
"서비스"에대한저작권및지적재산권은 "회사"에귀속됩니다. 단, "회원"의 "게시물" 및제휴계약에따라제공된저작물등은제외합니다.
"회사"는서비스와관련하여 "회원"에게 "회사"가정한이용조건에따라계정, "아이디", 콘텐츠, "포인트" 등을이용할수있는이용권만을부여하며, "회원"은이를양도, 판매, 담보제공등의처분행위를할수없습니다.
제 18 조 (포인트)
"회사"는서비스의효율적이용및운영을위해’사전공지후 "포인트"의일부또는전부를조정할수있으며, "포인트"는회사가정한기간에따라주기적으로소멸할수있습니다.
제 19 조 (계약해제, 해지등)
"회원"은언제든지서비스초기화면의고객센터또는내정보관리메뉴등을통하여이용계약해지신청을할수있으며, "회사"는관련법등이정하는바에따라이를즉시처리하여야합니다.
"회원"이계약을해지할경우, 관련법및개인정보취급방침에따라 "회사"가회원정보를보유하는경우를제외하고는해지즉시 "회원"의모든데이터는소멸됩니다.
"회원"이계약을해지하는경우, "회원"이작성한 "게시물" 중메일, 블로그등과같이본인계정에등록된게시물일체는삭제됩니다. 다만, 타인에의해담기, 스크랩등이되어재게시되거나, 공용게시판에등록된 "게시물" 등은삭제되지않으니사전에삭제후탈퇴하시기바랍니다.
제 20 조 (이용제한등)
"회사"는 "회원"이이약관의의무를위반하거나 "서비스"의정상적인운영을방해한경우, 경고, 일시정지, 영구이용정지등으로 "서비스" 이용을단계적으로제한할수있습니다.
"회사"는전항에도불구하고, "주민등록법"을위반한명의도용및결제도용, "저작권법" 및 "컴퓨터프로그램보호법"을위반한불법프로그램의제공및운영방해, "정보통신망법"을위반한불법통신및해킹, 악성프로그램의배포, 접속권한초과행위등과같이관련법을위반한경우에는즉시영구이용정지를할수있습니다. 본항에따른영구이용정지시 "서비스" 이용을통해획득한 "포인트" 및기타혜택등도모두소멸되며, "회사"는이에대해별도로보상하지않습니다.
"회사"는 "회원"이계속해서 3개월이상로그인하지않는경우, 회원정보의보호및운영의효율성을위해이용을제한할수있습니다.
"회사"는본조의이용제한범위내에서제한의조건및세부내용은이용제한정책및개별서비스상의운영정책 에서정하는바에의합니다.
본조에따라 "서비스" 이용을제한하거나계약을해지하는경우에는 "회사"는제9조["회원"에대한통지]에따라통지합니다.
"회원"은본조에따른이용제한등에대해 "회사"가정한절차에따라이의신청을할수있습니다. 이때이의가정당하다고 "회사"가인정하는경우 "회사"는즉시 "서비스"의이용을재개합니다.
제 21 조 (책임제한)
"회사"는천재지변또는이에준하는불가항력으로인하여 "서비스"를제공할수없는경우에는 "서비스" 제공에관한책임이면제됩니다.
"회사"는 "회원"의귀책사유로인한 "서비스" 이용의장애에대하여는책임을지지않습니다.
"회사"는 "회원"이 "서비스"와관련하여게재한정보, 자료, 사실의신뢰도, 정확성등의내용에관하여는책임을지지않습니다.
"회사"는 "회원" 간또는 "회원"과제3자상호간에 "서비스"를매개로하여거래등을한경우에는책임이면제됩니다.
"회사"는무료로제공되는서비스이용과관련하여관련법에특별한규정이없는한책임을지지않습니다.
제 22 조 (준거법및재판관할)
"회사"와 "회원" 간제기된소송은대한민국법을준거법으로합니다.
"회사"와 "회원"간발생한분쟁에관한소송은민사소송법상의관할법원에제소합니다.
부칙이약관은 2021년 11월1일일부터적용됩니다.


[개인정보 처리방침]
1. 수집하는개인정보의항목및수집방법
가. 수집하는개인정보의항목
첫째, 회사는회원가입, 원활한고객상담, 각종서비스의제공을위해최초회원가입당시아래와같은최소한의개인정보를필수항목으로수집하고있습니다.
- 아이디, 이름, 휴대전화번호, 이메일, 주소, 가입인증정보
나. 개인정보수집방법
회사는다음과같은방법으로개인정보를수집합니다.-홈페이지
2. 개인정보의수집및이용목적
가. 서비스제공에관한계약이행및서비스제공에따른요금정산
컨텐츠제공, 특정맞춤서비스제공
나. 회원관리
회원제서비스이용및제한적본인확인제에따른본인확인, 개인식별, 불량회원( SEMA INV이용약관제20조 1항중제11조 1항 1호~8호위반사유로인한영구이용정지및 2항에따라계약해지된영구이용정지회원)의부정이용방지와비인가사용방지, 가입의사확인, 가입및가입횟수제한, 만14세미만아동개인정보수집시법정대리인동의여부확인, 추후법정대리인본인확인, 분쟁조정을위한기록보존, 불만처리등민원처리, 고지사항전달, 회원탈퇴의사의확인
다. 신규서비스개발및마케팅•광고에의활용
신규서비스개발및맞춤서비스제공, 통계학적특성에따른서비스제공및광고게재, 서비스의유효성확인, 이벤트및광고성정보제공및참여기회제공, 접속빈도파악, 회원의서비스이용에대한통계
3. 개인정보의공유및제공
회사는이용자들의개인정보를 "2. 개인정보의수집목적및이용목적"에서고지한범위내에서사용하며, 이용자의사전동의없이는동범위를초과하여이용하거나원칙적으로이용자의개인정보를외부에공개하지않습니다.
다만, 아래의경우에는예외로합니다.-이용자들이사전에공개에동의한경우
- 법령의규정에의거하거나, 수사목적으로법령에정해진절차와방법에따라수사기관의요구가있는경우
5. 개인정보의보유및이용기간
이용자의개인정보는원칙적으로개인정보의수집및이용목적이달성되면지체없이파기합니다. 단, 다음의정보에대해서는아래의이유로명시한기간동안보존합니다.
가. 회사내부방침에의한정보보유사유
부정이용기록
보존이유 :부정이용방지
보존기간 : 1년
나. 관련법령에의한정보보유사유
상법, 전자상거래등에서의소비자보호에관한법률등관계법령의규정에의하여보존할필요가있는경우회사는관계법령에서정한일정한기간동안회원정보를보관합니다.
6. 개인정보파기절차및방법
이용자의개인정보는원칙적으로개인정보의수집및이용목적이달성되면지체없이파기합니다.
회사의개인정보파기절차및방법은다음과같습니다.
가. 파기절차
- 이용자가회원가입등을위해입력한정보는목적이달성된후별도의 DB로옮겨져(종이의경우별도의서류함) 내부방침및기타관련법령에의한정보보호사유에따라(보유및이용기간참조)일정기간저장된후파기됩니다.
- 동개인정보는법률에의한경우가아니고서는보유되는이외의다른목적으로이용되지않습니다.
나. 파기방법
- 종이에출력된개인정보는분쇄기로분쇄하거나소각을통하여파기합니다.
- 전자적파일형태로저장된개인정보는기록을재생할수없는기술적방법을사용하여삭제합니다.
7. 이용자및법정대리인의권리와그행사방법
- 이용자및법정대리인은언제든지등록되어있는자신혹은당해만 14세미만아동의개인정보를조회하거나수정할수있으며, 회사의개인정보의처리에동의하지않는경우동의를거부하거나가입해지(회원탈퇴)를요청하실수있습니다. 다만, 그러한경우서비스의일부또는전부이용이어려울수있습니다.
- 이용자혹은만 14세미만아동의개인정보조회, 수정을위해서는 '개인정보변경'(또는 '회원정보수정' 등)을, 가입해지(동의철회)를위해서는 "회원탈퇴"를클릭하여본인확인절차를거치신후직접열람, 정정또는탈퇴가가능합니다.
- 혹은개인정보관리책임자에게서면, 전화또는이메일로연락하시면지체없이조치하겠습니다.
- 이용자가개인정보의오류에대한정정을요청하신경우에는정정을완료하기전까지당해개인정보를이용또는제공하지않습니다. 또한잘못된개인정보를제3 자에게이미제공한경우에는정정처리결과를제3자에게지체없이통지하여정정이이루어지도록하겠습니다.
- 회사는이용자혹은법정대리인의요청에의해해지또는삭제된개인정보는 "5. 개인정보의보유및이용기간"에명시된바에따라처리하고그외의용도로열람또는이용할수없도록처리하고있습니다.
8. 개인정보자동수집장치의설치/운영및거부에관한사항
가. 쿠키란?
- 회사는개인화되고맞춤화된서비스를제공하기위해서이용자의정보를저장하고수시로불러오는 '쿠키(cookie)'를사용합니다.
- 쿠키는웹사이트를운영하는데이용되는서버가이용자의브라우저에게보내는아주작은텍스트파일로이용자컴퓨터의하드디스크에저장됩니다.
이후이용자가웹사이트에방문할경우웹사이트서버는이용자의하드디스크에저장되어있는쿠키의내용을읽어이용자의환경설정을유지하고맞춤화된서비스를제공하기위해이용됩니다.
- 쿠키는개인을식별하는정보를자동적/능동적으로수집하지않으며, 이용자는언제든지이러한쿠키의저장을거부하거나삭제할수있습니다.
나. 회사의쿠키사용목적
이용자들이방문한 SEMA INV의각서비스와웹사이트들에대한방문및이용형태, 인기검색어, 보안접속여부, 뉴스편집, 이용자규모등을파악하여이용자에게광고를포함한최적화된맞춤형정보를제공하기위해사용합니다.
다. 쿠키의설치/운영및거부
- 이용자는쿠키설치에대한선택권을가지고있습니다. 따라서이용자는웹브라우저에서옵션을설정함으로써모든쿠키를허용하거나, 쿠키가저장될때마다확인을거치거나, 아니면모든쿠키의저장을거부할수도있습니다.
- 다만, 쿠키의저장을거부할경우에는로그인이필요한 SEMA INV일부서비스는이용에어려움이있을수있습니다.
- 쿠키설치허용여부를지정하는방법(Internet Explorer의경우)은다음과같습니다.
1.[도구] 메뉴에서 [인터넷옵션]을선택합니다.
2.[개인정보탭]을클릭합니다.
3.[개인정보취급수준]을설정하시면됩니다.
9. 개인정보의기술적/관리적보호대책
회사는이용자들의개인정보를취급함에있어개인정보가분실, 도난, 누출, 변조또는훼손되지않도록안전성확보를위하여다음과같은기술적/관리적대책을강구하고있습니다.
가. 비밀번호암호화
 SEMA INV회원아이디(ID)의비밀번호는암호화되어저장및관리되고있어본인만이알고있으며, 개인정보의확인및변경도비밀번호를알고있는본인에의해서만가능합니다.
나. 해킹등에대비한대책
회사는해킹이나컴퓨터바이러스등에의해회원의개인정보가유출되거나훼손되는것을막기위해최선을다하고있습니다. 개인정보의훼손에대비해서자료를수시로백업하고있고, 최신백신프로그램을이용하여이용자들의개인정보나자료가누출되거나손상되지않도록방지하고있으며, 암호화통신등을통하여네트워크상에서개인정보를안전하게전송할수있도록하고있습니다. 그리고침입차단시스템을이용하여외부로부터의무단접근을통제하고있으며, 기타시스템적으로보안성을확보하기위한가능한모든기술적장치를갖추려노력하고있습니다.
다. 취급직원의최소화및교육
회사의개인정보관련취급직원은담당자에한정시키고있고이를위한별도의비밀번호를부여하여정기적으로갱신하고있으며, 담당자에대한수시교육을통하여 SEMA INV개인정보취급방침의준수를항상강조하고있습니다.
라. 개인정보보호전담기구의운영
그리고사내개인정보보호전담기구등을통하여 SEMA INV개인정보취급방침의이행사항및담당자의준수여부를확인하여문제가발견될경우즉시수정하고바로잡을수있도록노력하고있습니다.
단, 이용자본인의부주의나인터넷상의문제로 ID, 비밀번호, 주민등록번호등개인정보가유출되어발생한문제에대해회사는일체의책임을지지않습니다.
10. 개인정보관리책임자및담당자의연락처
귀하께서는회사의서비스를이용하시며발생하는모든개인정보보호관련민원을개인정보관리책임자혹은담당부서로신고하실수있습니다.
회사는이용자들의신고사항에대해신속하게충분한답변을드릴것입니다.
- 개인정보관리 : contact@bdavc.com
11. 기타
SEMA INV 에링크되어있는웹사이트들이개인정보를수집하는행위에대해서는본 "SEMA INV 개인정보취급방침"이적용되지않음을알려드립니다.
또한SEMA INV 모바일서비스에서의개인정보보호에대한상세한내용은 "SEMA INV 모바일개인정보보호정책"에서확인하실수있습니다.
12. 고지의의무
현개인정보취급방침내용추가, 삭제및수정이있을시에는개정최소 7일전부터홈페이지의 '공지사항'을통해고지할것입니다. 다만, 개인정보의수집및활용, 제3자제공등과같이이용자권리의중요한변경이있을경우에는최소 30일전에고지합니다.
- 공고일자 : 2022년6월10일
- 시행일자 : 2022년6월10일
				`,
			},
		}
	},
	computed: {
		nowWidth() {
			window.addEventListener('resize', () => {
				this.screenWidth = window.innerWidth
			})
			return this.screenWidth
		},
	},
	methods: {
		link() {
			window.open('https://www.sema.or.kr/sema/main/main.do ', '_self')
		},
	},
}
</script>
<style lang="scss">
.dialog1 {
	.qrtitle {
		height: 60px;
		display: flex;
		align-items: center;
		background-color: white;
		padding: 0 25px;

		h2 {
			color: white;
		}

		.title-icon {
			color: #cfd1d2;
		}
	}

	.dialog-content {
		padding: 0px 40px 40px 40px;
		.content {
			white-space: pre-line;
		}
	}
}
</style>
